import { render } from "./ContactComponent.vue?vue&type=template&id=66cadf9c&scoped=true"
import script from "./ContactComponent.vue?vue&type=script&lang=js"
export * from "./ContactComponent.vue?vue&type=script&lang=js"

import "./ContactComponent.vue?vue&type=style&index=0&id=66cadf9c&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cadf9c"]])

export default __exports__